<template>
  <v-app>
    <!-- Barra lateral de navegación -->
    <v-navigation-drawer app>
      <v-list-item title="SINTERED STONE" subtitle="Vuetify"></v-list-item>
      <v-list-item link to="/" title="Home"></v-list-item>
      <v-list-item link to="/jesus" title="Jesús"></v-list-item>
      <v-list-item link to="/Sam" title="Sam"></v-list-item>
      <!-- Agrega más enlaces a otras rutas si lo necesitas -->
    </v-navigation-drawer>

    <!-- Barra superior -->
    <v-app-bar app>
      <v-toolbar-title>SINTERED STONE</v-toolbar-title>
    </v-app-bar>

    <!-- Contenido principal -->
    <v-main>
      <!-- Aquí el enrutador se encargará de mostrar el componente correspondiente -->
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
}
</script>
